module.exports = __webpack_public_path__ + "static/media/YF86_08.7d60a88b.jpg";